import styled from 'styled-components';
import colors from '../../../../../styles/colors';
import { ReactComponent as SendIcon } from '../../assets/icon/send-icon.svg';
import { ReactComponent as AttachmentIcon } from '../../assets/icon/attachment.svg';
import { ReactComponent as MicIcon } from '../../assets/icon/mic-icon.svg';
import { ReactComponent as StopIcon } from '../../assets/icon/stop-icon.svg';
import { ReactComponent as closeIcon } from '../../../../../assets/icons/v2/cross-cancel.svg';

const MessagingInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.base.alpha};
`;

const StyledSendIcon = styled(SendIcon)`
  height: 30px;
  width: 30px;
`;

const StyledAttachmentIcon = styled(AttachmentIcon)`
  display: flex;
  height: 22px;
  width: 20px;
  > path {
    fill: ${colors.base.alpha};
  }
`;

const StyledMicIcon = styled(MicIcon)`
  display: flex;
  height: 20px;
  width: 20px;
  color: ${colors.base.secondary2};
  margin-left: 2px;
`;

const StyledStopIcon = styled(StopIcon)`
  display: flex;
  height: 20px;
  width: 20px;
  color: ${colors.shades.danger1};
  margin-left: 2px;
`;

const RecordingView = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  padding-right: 12px;
  font-size: 14px;
  color: ${colors.base.secondary2};
`;

const RecordingLabel = styled.div`
  display: flex;
  margin-left: 10px;
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

const ReplyMessageContainer = styled.div`
  padding: 5px 10px 10px 10px;
  width: 100%;
  background-color: ${colors.shades.primary1};
`;

const ReplyMessageContent = styled.div`
  display: flex;
  flex-direction: row;
`;

const ReplyMessage = styled.span`
  font-weight: 500;
  font-size: 14px;
  max-width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
`;

const StyledCloseIcon = styled(closeIcon)`
  width: 24px;
  height: 24px;
  > path {
    stroke: ${colors.base.secondary2};
  }
  cursor: pointer;
  margin: -12px 10px 0px auto;
`;

const ReplyDiscription = styled.span`
  color: ${colors.base.alpha};
  font-size: 12px;
  font-weight: 500;
`;

export {
  MessagingInputContainer,
  StyledSendIcon,
  StyledAttachmentIcon,
  StyledMicIcon,
  StyledStopIcon,
  RecordingView,
  RecordingLabel,
  ReplyMessageContainer,
  ReplyMessageContent,
  ReplyMessage,
  StyledCloseIcon,
  ReplyDiscription,
};
